<template>
    <div class="main-top form-top-section relative pb-24 z-40">
        <div class="section-bg bg-primary-gradient -bottom-half z-10 relative"></div>
        <div class="form-top-section-content container text-center z-10 relative">
            <div class="mx-auto pt-2 w-full md:w-1/2 px-2">
                <h1 class="text-green font-bold text-2xl md:text-3.5xl">Hi {{ customer.forename | capitalize }}</h1>
                <p
                    class="mt-4 md:mt-5 md:mb-0 text-lg md:text-1.5xl"
                >Let's get you a smaller loan!<br> We just need to know:</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['form', 'customer']
}
</script>

<style lang="scss">
</style>